import script from "./CompanyLabelComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyLabelComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__